import React, { useState } from 'react';
import {
    Paper,
    Typography,
    Box,
    Collapse,
    IconButton
} from '@mui/material';
import {
    ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';

const CollapsiblePanel = ({ children, defaultCollapsed = true, titleElement, title="Panel Title", onExpand, onCollapse }) => {
    const [isExpanded, setIsExpanded] = useState(!defaultCollapsed);

    const defaultTitleElement = (
        <Typography
            variant="subtitle1"
            component="h3"
            sx={{
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: 1
            }}
        >
            {title}
        </Typography>
    );

    titleElement = titleElement || defaultTitleElement;

    const handleExpandClick = () => {
        if (!isExpanded) {
            setIsExpanded(true);
            if (onExpand) onExpand();
        } else {
            setIsExpanded(false);
            if (onCollapse) onCollapse();
        }
    };
    // Children are always mounted. MUI Collapse hides them visually when
    // collapsed, but they stay in the DOM with state and refs intact, so:
    //   - filter selections survive collapse/expand
    //   - features that read refs (e.g., printing the Sankey chart) work
    //     even if the user never opened the panel

    return (
        <Paper
            elevation={1}
            sx={{
                p: 2,
                mb: 2,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5, pl: 2}}>
                {titleElement}
                <IconButton
                    onClick={handleExpandClick}
                    sx={{
                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease-in-out'
                    }}
                    size="small"
                >
                    <ExpandMoreIcon />
                </IconButton>
            </Box>
            <Collapse in={isExpanded} timeout={300}>
                {children}
            </Collapse>
        </Paper>
    );
};

export default CollapsiblePanel;